import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { BillerResult, TokenResult } from "../domain/entities/Main";
import { usePopup } from "../../../shared/hooks/usePopup";
import MainUseCase from "../domain/usecases/MainUseCase";
import MainApi from "../data/MainApi";
import { saveMenu } from "../../../shared/lib/localStorage";

export function useBiller(tokenResponse: TokenResult | null | undefined) {
  const { showPopup, handleErrorResponse } = usePopup();
  const [isBillerLoading, setIsBillerLoading] = useState<boolean>(true);
  const [billerResponse, setBillerResponse] = useState<
    BillerResult | null | undefined
  >(null);

  const repository = new MainUseCase(new MainApi());
  const {
    isLoading,
    data: billerResult,
    error,
    isError,
  } = useQuery({
    enabled: !!tokenResponse && tokenResponse.responseDesc === "", // Only fetch when token exists
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: ["biller", tokenResponse],
    queryFn: async () => repository.getBiller(),
  });

  useEffect(() => {
    if (!isLoading && billerResult) {
      saveMenu(JSON.stringify(billerResult.data));
      setIsBillerLoading(false);
      setBillerResponse(billerResult);
    }
  }, [isLoading, billerResult]);

  useEffect(() => {
    if (error && error instanceof AxiosError && isError) {
      handleErrorResponse(error);
    }
  }, [error, isError]);

  return { billerResponse, isBillerLoading };
}
